import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominaTimbresGenerarxmlConfirmarComponent {
  completado
  completados
  error
  generando
  regenerar
  versionFactura
  versionesFacturas

  constructor(NominaTimbresTimbreXML) {
    this.NominaTimbresTimbreXMLService = NominaTimbresTimbreXML
    this.completado = false
    this.completados = []
    this.error = null
    this.generando = false
    this.regenerar = false
  }

  $onInit () {
    this.progreso = {
      total: this.data.length,
      completados: 0,
      porcentaje: 0,
    }
  }

  generar () {
    this.pendientes = this.data.filter((item) => {
      return this.regenerar
        ? true
        : item.xml_generado === false
    })

    this.siguiente()
  }

  siguiente () {
    this.generando = true

    if (this.pendientes.length > 0) {

      let generando = this.pendientes.shift()

      this.NominaTimbresTimbreXMLService.post(generando.id_nomina, generando.id_empresa, generando.id_empleado, generando.indice, this.versionFactura)
        .then(() => {
          this.completados.push(generando)

          this.progreso.completados = this.completados.length
          this.progreso.porcentaje = this.progreso.completados / this.progreso.total

          this.siguiente()
        })
        .catch(() => {
          this.error = 'Se ha generado un error.'
          this.completado = true
        })

    } else {
      this.completado = true
    }
  }

  cerrar () {
    this.onClose({
      $event: {
        data: this.completados,
      },
    })
  }
}

module.component('nominaTimbresGenerarxmlConfirmar', {
  controller: NominaTimbresGenerarxmlConfirmarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    data: '<',
    omitidos: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/generarxml/confirmar/component.js